<template>
    <div class="crop-popup">
        <vue-cropper ref="cropper" alt="Source Image"> </vue-cropper>

        <i class="material-icons close" @click="close">close</i>

        <div class="buttons">
            <a class="button" color="accent" @click="rotate">
                <i class="icon">rotate_right</i>
                <span>ROTATE</span>
            </a>

            <a class="button" color="accent" :state="loading ? 'load' : ''" @click="save($event)">
                <i class="icon">save</i>
                <span>SAVE</span>
            </a>
        </div>
    </div>
</template>

<script>
// https://github.com/fengyuanchen/cropperjs/blob/master/README.md

import VueCropper from 'vue-cropperjs';
import { mapActions } from 'vuex';

export default {
    name: 'profile',

    components: {
        VueCropper,
    },

    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            name: null,
        };
    },

    mounted() {
        this.$refs.cropper.setAspectRatio(1);
    },

    methods: {
        ...mapActions(['uploadActorPhoto']),

        replace(result, name) {
            this.name = name;
            this.$refs.cropper.replace(result);
        },

        close() {
            this.$emit('close', true);
        },

        save(event) {
            let button = event.target.closest('.button');

            // if already saving, return
            if (this.loading) {
                return;
            }

            this.$emit('save', this.dataURItoBlob(this.$refs.cropper.getCroppedCanvas().toDataURL('image/png')));

            // button.setAttribute('state', 'load');
            // this.uploadActorPhoto({
            //     image: this.dataURItoBlob(this.$refs.cropper.getCroppedCanvas().toDataURL('image/png')),
            //     name: this.name || `${Math.random().toString(36).substring(2)}.png`,
            // }).then((response) => {
            //     this.$emit('saved', response.data.uri);
            //     button.removeAttribute('state');
            // });
        },

        rotate() {
            this.$refs.cropper.rotate(90);
        },

        dataURItoBlob(dataURI) {
            // Convert base64/URLEncoded data component to raw binary data held in a string, for form-data
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
            else byteString = unescape(dataURI.split(',')[1]);
            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], { type: mimeString });
        },
    },
};
</script>

<style lang="less" scoped>
// Komponent nenacitava styly z cropper.css, just workaround

@import 'CropperJS.less';

.crop-popup {
    box-shadow: 0px 10px 50px 10px rgba(0, 0, 0, 0.6);

    // @media (max-width: 829px) {
    // 	position: relative;
    // 	width: 100%;
    // 	height: ~"calc(100vh - 80px)";
    // 	padding: 20px;
    // }

    // @media(min-width: 830px) {
    position: fixed;
    z-index: 300;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: ~'calc(100% - 50px)';
    border-radius: 20px;
    overflow: hidden;

    max-width: 700px;
    max-height: 700px;
    // }

    @media (max-height: 720px) {
        max-height: 90%;
    }

    .close {
        position: absolute;
        top: 5px;
        right: 5px;
        color: white;
        font-size: 30px;
        cursor: pointer;
    }

    .buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        // @media(max-width: 829px) {
        // 	margin: 20px auto 0 auto;
        // 	width: 100;
        // }

        // @media(min-width: 830px) {
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        width: ~'calc(100% - 15px)';
        // }
    }
}
</style>
